import apiClient from './apiClient'

export const ACCESS_KEY = 'portal-access-key'

export const getInstitutionInternshipRequestPortal = (institutionUuid, portalAccessKey) => apiClient.get(
  null,
  `public/internship-request-portal/institution/${institutionUuid}`,
  { [ACCESS_KEY]: portalAccessKey }
)

export const getInstitutionGroupInternshipRequestPortal = (institutionGroupUuid, portalAccessKey) => apiClient.get(
  null,
  `public/internship-request-portal/institution-group/${institutionGroupUuid}`,
  { [ACCESS_KEY]: portalAccessKey }
)
